import { useEffect, useState } from 'react';

/**
 * True while any Radix dialog/sheet (role="dialog", data-state="open") is mounted.
 * Used to suppress floating chat/promo widgets (Skjul Chat FAB, Agentic promo)
 * so they never overlap a modal's footer/content. (Fase 1 amendments A & B.)
 */
export function useAnyModalOpen(): boolean {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const check = () => setOpen(!!document.querySelector('[role="dialog"][data-state="open"]'));
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-state'],
    });
    return () => observer.disconnect();
  }, []);
  return open;
}
